import * as Cesium from "cesium";
import * as mars3d from "mars3d";

let BaseTileLayer = mars3d.layer.BaseTileLayer;

/**
 * 超图影像瓦片服务图层,
 * 【需要引入  mars3d-supermap 插件库】
 *
 * @param {Object} options 参数对象，包括以下：
 * @param {BaseTileLayer.ConstructorOptions} [options.通用参数] 包含父类支持的所有参数
 *
 * @param {Boolean} [options.transparent=true] 设置请求的地图服务的参数是否为transparent。
 * @param {String} [options.tileFormat] 影像图片格式，默认为png。
 * @param {String} [options.cacheKey] 影像的三维缓存密钥。
 *
 * @param {String|Cesium.Color} [options.transparentBackColor] 设置影像透明色。
 * @param {Number} [options.transparentBackColorTolerance] 去黑边,设置影像透明色容限，取值范围为0.0~1.0。0.0表示完全透明，1.0表示完全不透明。
 *
 * @export
 * @class SmImgLayer
 * @extends {BaseTileLayer}
 *
 * @see http://support.supermap.com.cn:8090/webgl/docs/Documentation/SuperMapImageryProvider.html?classFilter=SuperMapImageryProvider
 */
export class SmImgLayer extends BaseTileLayer {
  //构建ImageryProvider
  _createImageryProvider(options) {
    return createImageryProvider(options);
  }
  //添加时
  _addedHook() {
    super._addedHook();

    if (Cesium.defined(this.options.transparentBackColorTolerance)) {
      this._imageryLayer.transparentBackColorTolerance = this.options.transparentBackColorTolerance; //去黑边
    }
  }
}
function createImageryProvider(options) {
  options = mars3d.LayerUtil.converOptions(options);
  return new Cesium.SuperMapImageryProvider(options);
}

/**
 * 创建用于图层的 ImageryProvider对象
 *
 * @param {Object} options Provider参数，同图层构造参数。
 * @return {Cesium.SuperMapImageryProvider} ImageryProvider类
 * @function
 */
SmImgLayer.createImageryProvider = createImageryProvider;

mars3d.layer.SmImgLayer = SmImgLayer;

//注册下
const layerType = "supermap_img";
mars3d.LayerUtil.register(layerType, SmImgLayer);
mars3d.LayerUtil.registerImageryProvider(layerType, createImageryProvider);
